import { useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './MessageAndDocument.scss';
import DocumentIndex from './DocumentsUpload/DocumentIndex';
import PublishMessage from './publishMessage/PublishMessage';
import { useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import ToastMessage from 'src/Admin/components/common/ToastMessage';
import UpdatesRemainder from './Updates&Remainders/UpdatesRemainder';
import useMyMessage from './Messages/hook/useMyMessage';
import MessagingFiltersScreen from './Messages/MessagingFiltersScreen';
import Header from '../common/Header/Header';
import { useSelector } from 'react-redux';

function MessageAndDocument() {
  const { t } = useTranslation();
  const location = useLocation();

  const [messageCount] = useState(location?.state?.notificationCount);
  const [selectedTabLocal, setSelectedTabLocal] = useState('');
  const [setShowNotification] = useState(location?.state?.setShowNotification);
  const [messageSelectedFromPopup] = useState(location?.state?.popUpMessage);
  const [isComposed, setIsComposed] = useState(false);

  const {
    getSendReceiveMessageList,
    sortByData,
    searchText,
    typeData,
    SortByDummyOptions,
    typeOptionList,
    setSortByData,
    setTypeData,
    AttachmentOptions,
    attachmentData,
    setAttachmentData,
    onSearch,
    resetFilterHandler,
    isComposing,
    setIsComposing,
    replyEnabled,
    setReplyEnabled,
    listApiServerError,
    listApiDataNotFoundError,
    listLoading,
    filteredData,
    totalRecords,
    pageSize,
    currentPage,
    displayPaginationMininumCount,
    pageSizeHandler,
    paginationHandler,
    selectedTab,
    setSelectedTab,
    setSelectedIndex,
    selectedIndex,
    setSelectedIndexForSent,
    selectedIndexForSent,
    messageDetailData,
    setMessageDetailData,
    setCurrentPage,
    getSanitizedContent,
    downloadFileHandler,
    downloadAllFileHandler,
    markeMessageAsRead,
  } = useMyMessage({
    messageSelectedFromPopup,
    setIsComposed,
    selectedTabLocal,
  });

  const tabClickHandler = (e) => {
    setSelectedTabLocal(e);
  };

  const { NotificationResp } = useSelector(
    (state) => state?.messageAndNotification,
  );

  useEffect(() => {
    if (selectedTabLocal === 'messages') {
      getSendReceiveMessageList('messages');
    }
  }, [selectedTabLocal]);

  useEffect(() => {
    if (isComposed) {
      setIsComposing(false);
      setSelectedTabLocal(null);
      setTimeout(() => {
        setSelectedIndexForSent(0);
        setSelectedTabLocal('messages');
      }, 1000);
    }
  }, [isComposed]);

  const getTitle = (title, count) => {
    return (
      <span>
        {title}{' '}
        {messageCount && count && (
          <span className="mymessage-count"> {count} </span>
        )}
      </span>
    );
  };

  useEffect(() => {
    if (location?.state?.comingFrom) {
      if (location?.state?.comingFrom === 'publish-new-message') {
        setSelectedTabLocal('published-messages');
        if (location?.state.publishedSuccessfully === true) {
          toast.success(
            <ToastMessage
              type="success"
              subTitle="New Message Published successfully."
            />,
          );
        }
      }
    }
  }, []);

  useEffect(() => {
    setShowNotification && setShowNotification(false);
    if (
      location?.state?.showmymessage === true ||
      location?.state?.comingFrom === 'messages'
    ) {
      tabClickHandler('messages');
    }
    if (
      location?.state?.showdocuments === true ||
      location?.state?.selectedTabDocument === true
    ) {
      tabClickHandler('document');
    }
    if (location?.state?.shownotification === true) {
      tabClickHandler('notification');
    }
  }, [location.state]);

  return (
    <div id="messagedocument" className="Messaging_and_Documents">
      <div className="container-offset">
        <Header
          linkTo={'/admin/admin-dashboard'}
          header={t('member.messaging.main_title')}
          //mandatoryLabel={t('mandatory_label')}
          //preserveData={{ comingFrom: 'duplicate-resource' }}
        />
      </div>
      <div className="mt-3">
        <Tabs
          activeKey={selectedTabLocal}
          defaultActiveKey="messages"
          id="uncontrolled-tab-example"
          className="mb-3 tabs-class-admin"
          onSelect={tabClickHandler}
        >
          {(selectedTabLocal === 'messages' || true) && (
            <Tab
              eventKey="messages"
              title={getTitle(
                'My Messages',
                NotificationResp?.MessageCount?.Message > 0 &&
                  NotificationResp?.MessageCount?.Message,
              )}
            >
              <MessagingFiltersScreen
                sortByData={sortByData}
                searchText={searchText}
                typeData={typeData}
                SortByDummyOptions={SortByDummyOptions}
                typeOptionList={typeOptionList}
                setSortByData={setSortByData}
                setTypeData={setTypeData}
                AttachmentOptions={AttachmentOptions}
                attachmentData={attachmentData}
                setAttachmentData={setAttachmentData}
                onSearch={onSearch}
                resetFilterHandler={resetFilterHandler}
                isComposing={isComposing}
                setIsComposing={setIsComposing}
                replyEnabled={replyEnabled}
                setReplyEnabled={setReplyEnabled}
                listApiServerError={listApiServerError}
                listApiDataNotFoundError={listApiDataNotFoundError}
                listLoading={listLoading}
                filteredData={filteredData}
                totalRecords={totalRecords}
                pageSize={pageSize}
                currentPage={currentPage}
                displayPaginationMininumCount={displayPaginationMininumCount}
                pageSizeHandler={pageSizeHandler}
                paginationHandler={paginationHandler}
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
                setSelectedIndex={setSelectedIndex}
                selectedIndex={selectedIndex}
                setSelectedIndexForSent={setSelectedIndexForSent}
                selectedIndexForSent={selectedIndexForSent}
                messageSelectedFromPopup={messageSelectedFromPopup}
                messageDetailData={messageDetailData}
                setMessageDetailData={setMessageDetailData}
                setCurrentPage={setCurrentPage}
                getSanitizedContent={getSanitizedContent}
                downloadFileHandler={downloadFileHandler}
                downloadAllFileHandler={downloadAllFileHandler}
                setIsComposed={setIsComposed}
                markeMessageAsRead={markeMessageAsRead}
              />
            </Tab>
          )}
          {(selectedTabLocal === 'document' || true) && (
            <Tab
              eventKey="document"
              //title={getTitle('Documents', messageCount?.Document)}
              title="Documents"
            >
              <DocumentIndex />
            </Tab>
          )}
          {(selectedTabLocal === 'notification' || true) && (
            <Tab
              eventKey="notification"
              title={getTitle(
                'Updates/Reminders',
                NotificationResp?.MessageCount?.Notification > 0 &&
                  NotificationResp?.MessageCount?.Notification,
              )}
            >
              <UpdatesRemainder selectedTabLocal={selectedTabLocal} />
            </Tab>
          )}
          {(selectedTabLocal === 'published-messages' || true) && (
            <Tab
              eventKey="published-messages"
              title={getTitle('Published Messages', '')}
            >
              <PublishMessage
                selectedTab={selectedTabLocal}
                publishedSuccess={location?.state?.selectedTabDocument}
              />
            </Tab>
          )}
        </Tabs>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default MessageAndDocument;
